import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/commands';
import { App } from '@/ui/App';
import { ErrorBoundary } from '@/ui/ErrorBoundary';
import './ui/styles.css';

/**
 * Entry point.
 *
 * Importing `@/commands` for its side effects registers every command before
 * anything can dispatch one; without it a production build could tree-shake a
 * command module that is only referenced through the registry.
 */

const container = document.getElementById('root');
if (!container) throw new Error('Root element is missing.');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Offline support is an enhancement; the DAW works without it.
    });
  });
}
